<template>
  <li class="divide-y">
    <div
      class="block pr-6 py-4 text-gray-600"
      :class="[
        isFocused ? 'bg-blue-100 font-bold' : 'bg-white',
        isFocused ? 'text-blue-800' : 'bg-white',
      ]"
      :style="{
        paddingLeft: `${indent * 1.5}rem`,
      }"
      @click="focusOrderItem(orderItem.uuid)"
    >
      {{ orderItem.name }}
    </div>

    <ul v-if="hasChildren" class="divide-y">
      <OrderItemNavItem
        v-for="child in children"
        :key="child.uuid"
        :order-item="child"
        :indent="indent + 1"
        :focused-order-item-id="focusedOrderItemId"
        @order-line:focus="focusOrderItem"
      />
    </ul>
  </li>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'OrderItemNavItem',

  props: {
    orderItem: {
      type: Object,
      required: true,
    },
    indent: {
      type: Number,
      default: 1,
    },
    focusedOrderItemId: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState('entities', {
      product({ products }) {
        if (!this.orderItem.product) return null;

        return products.byId[this.orderItem.product] || null;
      },
      children({ orderItems }) {
        const allIds = Object.keys(orderItems.byId);

        return allIds
          .map((id) => orderItems.byId[id])
          .filter((orderItem) => orderItem.parentOrderItemUuid === this.orderItem.uuid);
      },
    }),
    productType() {
      if (!this.product) return null;
      return this.product.type;
    },
    hasChildren() {
      return this.children.length > 0;
    },
    isFocused() {
      return this.focusedOrderItemId === this.orderItem.uuid;
    },
  },

  methods: {
    focusOrderItem(orderItemUuid) {
      this.$emit('order-line:focus', orderItemUuid);
    },
  },
};
</script>
